import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import openPrintDialog from "@insite/client-framework/Common/Utilities/openPrintDialog";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import { API_URL_CURRENT_FRAGMENT, post } from "@insite/client-framework/Services/ApiService";
import { Cart, getCart, GetCartApiParameter } from "@insite/client-framework/Services/CartService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import { BillToModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import AddressInfoDisplay from "@insite/content-library/Components/AddressInfoDisplay";
import Button from "@insite/mobius/Button";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import { HasToasterContext, withToaster } from "@insite/mobius/Toast/ToasterContext";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { ChangeEvent, useEffect, useState } from 'react';
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    image = "image",
    webQuoteTextColor = "webQuoteTextColor"
}

interface OwnProps {
    fields: {
        [fields.image]: string;
        [fields.webQuoteTextColor]: string;
    };

}

const mapStateToProps = (state: ApplicationState) => ({
    session: getSession(state),
    currentState: state,
    signInPageUrl: getPageLinkByPageType(state, "SignInPage")?.url,
    cartPageUrl: getPageLinkByPageType(state, "CartPage")?.url,
    cartState: getCurrentCartState(state),
    cartData: getCartState(state, "current"),
    cartId: state.pages.checkoutReviewAndSubmit,
    webQuoteSettings: getSettingsCollection(state)

});
const mapDispatchToProps = {

};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasToasterContext &
    HasHistory & HasShellContext;
export interface WebQuoteStyles {
    webQuote?: InjectableCss;
}
interface BaseWebQuoteCart {
    QuoteData: WebQuoteCart | undefined;
    QuoteName: string;
    QuoteNotes: string;
    quoteNumber: string;

}

interface WebQuoteCart {
    cart: Cart;
    billTo: BillToModel | undefined;
    shipTo: ShipToModel | undefined;
}
interface AspenWebQuoteSettings {
    QuoteValidUntil: number;
}
export const WebQuote: React.FC<Props> = ({ fields, session, currentState, webQuoteSettings, history, signInPageUrl, cartPageUrl }) => {
    const [quoteSubmitted, setQuoteSubmitted] = React.useState(false);
    const [quoteNumber, setQuoteNumber] = React.useState<string>("");
    const [data, setData] = useState<WebQuoteCart>();
    const { shipToId } = session;
    const [validTillDate, setValidTillDate] = useState<string>("");
    const [quoteDate, setQuoteDate] = useState<string>("");
    const [apiUrl, setApiUrl] = useState<string>("");
    const shipToState = getShipToState(currentState, shipToId);
    const { value: shipTo } = shipToState;
    const [quoteName, setQuoteName] = useState<string>("");
    const [quoteNotes, setQuoteNotes] = useState<string>("");
    const [isSubmitCLicked, setIsSubmitCLicked] = React.useState(false);
    const { isInShell } = useShellContext();

    useEffect(() => {
        const currentURL: string = window.location.href;
        if(!isInShell) 
         {
            if (!session.isAuthenticated) {
                signInPageUrl = signInPageUrl || "signin";
                history.push(`${signInPageUrl}`);
                return;
            }
        }
        const currentDate = new Date();
        const futureDate = new Date(currentDate);
        const aspenWebQuoteSettings: AspenWebQuoteSettings = webQuoteSettings.aspenWebQuoteSettings as AspenWebQuoteSettings;
        futureDate.setDate(currentDate.getDate() + aspenWebQuoteSettings?.QuoteValidUntil);
        const options: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };
        const formattedDate = currentDate.toLocaleDateString('en-US', options);
        const formattedValidTillDate = futureDate.toLocaleDateString('en-US', options);
        setQuoteDate(formattedDate);
        setValidTillDate(formattedValidTillDate);

        const url: URL = new URL(currentURL);
        setApiUrl(url.origin);

    }, []);
    useEffect(() => {
        const fetchCartata = async () => {
            try {
                const cartResult = await getCart({
                    cartId: API_URL_CURRENT_FRAGMENT,
                    expand: ["cartLines", "hiddenproducts",
                        "paymentOptions"],
                } as GetCartApiParameter);
                setData(cartResult);
            } catch (error) {
                // console.error('Error fetching data:', error);
            }
        };
        fetchCartata();
    }, []);


    const webQuoteData = {
        QuoteData: data,
        QuoteName: quoteName,
        QuoteNotes: quoteNotes
    };
    const SubmitWebQuote = () => {

        const apiUrl = '/api/v1/webquote/postwebdata';

        return post<BaseWebQuoteCart>(apiUrl, {
            QuoteData: webQuoteData.QuoteData,
            QuoteName: webQuoteData.QuoteName,
            QuoteNotes: webQuoteData.QuoteNotes

        } as BaseWebQuoteCart);

    }

    const SubmitQuote = () => {

        SubmitWebQuote()
            .then(responsedata => {
                setIsSubmitCLicked(false);
                if (responsedata.quoteNumber) {
                    setQuoteSubmitted(true);
                    setQuoteNumber(responsedata.quoteNumber);
                    if (data !== undefined) {
                        //
                    }
                }
                // console.log('Response data:', data);
            })
            .catch(error => {
                // console.error('Error:', error);
            });
    }

    const handleQuoteSubmit = () => {
        setIsSubmitCLicked(true);
        SubmitQuote();
    };

    const quoteNameChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setQuoteName(value);
    };
    const quoteNotesChangeHandler = (event: ChangeEvent<HTMLTextAreaElement>) => {
        const value = event.target.value;
        setQuoteNotes(value);
    };

    const newWeQuoteClick = () => {
        window.location.href = `${cartPageUrl}`;
    };

    const webquoteStyles: WebQuoteStyles = {
        webQuote: {
            css: css`   
                .container-main {
                    @media (min-width: 768px) {
                        padding-left: 100px;
                        padding-right: 100px;
                    }
                    img{
                        max-width: 333px;
                    }
                }

                .table-data {
                    color: #ffffff;
                    background-color: #58595b;
                    width: 885px;
                }
                .result-text {
                    font-weight: bold;
                    font-size: 11px;
                    color: #ffffff;
                    text-align: left;
                    @media (min-width: 768px) {
                        font-size: 16px;
                    }
                }
                .quote-price {
                    margin-left: 35px;
                    float: right;
                }
                .edit-quote {
                    background-color: #9ADBE8;
                    border-color: #9ADBE8;
                    @media (max-width: 767px) {
                        width:198.5px;
                        margin-left: 5px; 
                        margin-top:5px;
                    }
                    @media (min-width: 768px) {
                        margin-top:10px;
                        margin-bottom:10px;
                    }
                   
                }
                .edit-quote:hover {
                    background-color: hsl(190, 70%, 40%);
                    border-color: hsl(190, 70%, 40%);
                    opacity: 0.87;
                }
                .submit-web-quote {
                    background-color: #9ADBE8;
                    border-color: #9ADBE8;             
                    margin-left: 30px;  
                    @media (max-width: 767px) {
                        margin-left: 5px; 
                        margin-top:5px;
                    }
                    @media (min-width: 768px) {
                        margin-top:10px;
                        margin-bottom:10px;
                    }
                }
                .submit-web-quote:hover, .edit-quote:hover{
                    background-color: hsl(190, 70%, 40%);
                    border-color: hsl(190, 70%, 40%);
                    opacity:0.87;
                }
                .web-quote {
                    color: red;
                    font-size: 34px;
                }
                .row2-column1 {
                    color: ${fields.webQuoteTextColor};
                    width: 885px;
                    font-size: 18px;
                    @media (min-width: 768px) {
                        font-size: 30px;
                    }
                }
                .row2-column2 {
                    color: #555555;
                    width: 885px;
                    font-size: 7px;

                    @media (min-width: 768px) {
                        font-size: 16px;
                    }
                }
                .logo {
                    font-size: 25px;
                    font-weight: 900;
                    @media (min-width: 768px) {
                        font-size: 40px;
                        font-weight: 900;
                    }
                }
                .row3-column2 {
                    color: #555555;
                    font-size: 7px;

                    @media (min-width: 768px) {
                        font-size: 16px;
                    }
                    span{
                        display:block;
                    }
                }
                .row3-column1 {
                    color: #555555;
                    font-size: 6px;
                    display: grid;
                    @media (min-width: 768px) {
                        font-size: 16px;
                    }
                }
                .add-margin-top{
                    margin-top:20px;
                }
                .width-for-column{
                    width:55%;
                }
                .quote-detail-div{
                    float:right;
                    width:100%;
                }
                .summary-table {
                    color: #ffffff;
                    background-color: #58595b;
                    width: 1400px;
                    font-size: 7px;
                    @media (min-width: 768px) {
                        font-size: 14px;
                    }
                }
                .quote-price-list {
                    font-size: 12px!important;
                    margin-right: 30px;

                    @media (min-width: 768px) {
                        font-size: 16px!important;
                        margin-right: 70px;
                    }
                }
                .quote-summary-output {
                    background-color: #eeeeee;

                    font-size: 7px;
                    margin: 0;
                    padding: 0;
                    @media (min-width: 768px) {
                        font-size: 15px;
                    }
                }
                .center-text {
                    font-size: 6px;
                    display: block;
                    text-align: center;
                    @media (min-width: 768px) {
                        font-size: 11px;
                    }
                }
                .terms-condition {
                    margin-top: 15px;
                    display:block;
                    font-size: 9px;
                    @media (min-width: 768px) {
                        font-size: 14px;
                    }
                }
                .gp-quote-total {
                    display: block;
                    text-align: right;
                    font-size: 6px;
                    @media (min-width: 768px) {
                        font-size: 14px;
                    }
                }
                @media only screen and (max-width: 600px) {
                    th,
                    td {
                        font-size: 6px;
                    }

                    td {
                    }
                }
                .quote-numb{
                    float: right;
                    margin-right: 0px;
                    padding-top: 30px;
                    @media (min-width: 768px) {
                        float: right;
                        margin-right: 0px;
                        padding-top: 90px;                    }
                }

                .quote-detail{
                    vertical-align:bottom;
                }
                .quote-detail-left{
                    float:left
                }
                .quote-detail-right{
                    float:right
                }
                @media (min-width: 768px) {
                    .quote-detail{
                        width:40%;
                    }
                    .add-margin-label{
                        margin-bottom:5px;
                    }
                    .row-space{
                        border-collapse: collapse;
                        width: 100%;
                    }
                }
                @media (max-width: 767px) {
                    .quote-detail{
                        width:45%;
                    }
                    .mobile-column-width{
                        width:50%;
                    }
                    .add-margin-label{
                        margin-bottom:10px;
                    }
                }
                input[type="text"], textarea{
                    padding: 0.2rem 0.4rem 
                }
                .add-margin-textbox{
                    margin-bottom:5px;
                }
                .note{
                    font-size: 6px;
                    p{
                        font-size: 7px;
                        margin-bottom:2px;
                    }
                    @media (min-width: 768px) {
                        font-size: 16px;
                        p{
                            font-size: 18px; 
                        }
                    }
                }
                .info{
                    color: #555555;
                    font-size: 7px;
                    display: grid;
                    @media (min-width: 768px) {
                        font-size: 18px;
                    }
                    a{
                        color: #b7410f;
                    }
                }
                .quote-style{
                    vertical-align:middle;
                }
                .overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100vw;
                    height: 100vh;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 9999; 
                    
                  }
                  .webQuoteSpinner {
                    position: relative;
                  }
                  textarea{
                    resize:none;
                  }
                  .onlyPrint{
                    display:none;
                  }

                @media (max-width: 994px) {
                    table{
                        font-size: 7px;
                    }
                    .line{
                        width: 9%;
                    }
                    .line-counter{
                        width: 8%;
                    }
                    .original-item{
                        width: 9%;
                    }
                    .original-item-header{
                        width: 13%;
                    }
                    .item{
                        width: 0%;
                    }
                    .aspen-item{
                        width: 0%;
                    }
                    .part-desc{
                        width: 20%;
                    }
                    .part-desc-content{
                        width: 20%;
                    }
                    .qty{
                        width: 8%;
                    }
                    .lp{
                        width: 14%;
                    }
                    .list-price{
                        width: 11%;
                    }
                    .dis{
                        width: 3%;
                    }
                    .unit-price{
                        width: 13%;
                    }
                    .total{
                        width: 11%;
                    }
                    .row-space{
                        border-collapse: collapse;
                        width: 100%;
                    }
                }

                @media print{
                    .onlyUI{
                        display: none;
                    }
                    .onlyPrint{
                        display:block;
                    }
                    table{
                        font-size: 10px;
                    }
                    .part-desc{
                        width: 25%;
                    }
                    .original-item{
                        width: 13%;
                    }
                    .aspen-item{
                        width: 11%;
                    }
                    .part-desc-content{
                        width: 25%;
                    }
                    .list-price{
                        width: 8%;
                    }
                    .line{
                        width: 7%;
                    }
                    .item{
                        width: 11%;
                    }
                    .line-counter{
                        width: 8%;
                    }
                    .lp{
                        width: 9%;
                    }
                    .qty{
                        width: 4%;
                    }
                    .dis{
                        width: 9%;
                    }
                    .unit-price{
                        width: 9%;
                    }
                    .up{
                        width: 9%;
                    }
                    .total{
                        width: 9%;
                    }
                    .row2-column1{
                        visibility: hidden;
                    }
                    .row3-column1{
                        font-size: 14px !important;
                    }
                    .row2-column2{
                        font-size: 14px;
                    }
                    .quote-numb {
                        font-size: 14px;
                        font-weight: bold;
                    }
                    .center-text{
                        font-size: 14px;
                        font-weight: bold;
                        color: ${fields.webQuoteTextColor};
                    }
                    @media print and (max-width: 414px) {
                        @supports (-webkit-touch-callout: none) {
                            .center-text{
                                font-size: 10px;
                                font-weight: 600;
                                color: ${fields.webQuoteTextColor};
                            }
                        }
                    }
                    @media print and (max-width: 767px) {
                        @supports (-webkit-touch-callout: none) {
                            .center-text{
                                font-size: 10px;
                                font-weight: 600;
                                color: ${fields.webQuoteTextColor};
                            }
                        }
                    }
                    .row-space{
                        border-collapse: separate !important;
                        border-spacing: 0 1em;
                        position: relative;
                        bottom: 35px;
                    }
                    @media print and (max-width: 414px) {
                        @supports (-webkit-touch-callout: none) {
                            .row-space
                            {  
                                border-collapse: separate !important;
                                border-spacing: 0 1em;
                                position: relative;
                                bottom: 10px;
                            }
                        }
                    }
                    @media print and (max-width: 767px) {
                        @supports (-webkit-touch-callout: none) {
                            .row-space
                            {  
                                border-collapse: separate !important;
                                border-spacing: 0 1em;
                                position: relative;
                                bottom: 10px;
                            }
                        }
                    }
                    .gp-quote-total{
                        font-size: 14px;
                        color: ${fields.webQuoteTextColor};
                        position: relative;
                        bottom: 30px;
                    }
                    @media print and (max-width: 414px) {
                        @supports (-webkit-touch-callout: none) {
                            .gp-quote-total{
                                font-size: 14px;
                                position: relative;
                                bottom: 0px;
                                color: ${fields.webQuoteTextColor};
                            }
                        }
                    }
                    @media print and (max-width: 767px) {
                        @supports (-webkit-touch-callout: none) {
                            .gp-quote-total{
                                font-size: 14px;
                                position: relative;
                                bottom: 0px;
                                color: ${fields.webQuoteTextColor};
                            }
                        }
                    }
                    .row3-column1 span{
                        font-size: 14px !important;
                    }
                    .quote-detail-div tr {
                        font-size: 14px !important;
                    }
                    .pdf-logo-align{
                        position: relative;
                        bottom: 175px;
                    }
                    @media print and (max-width: 414px) {
                        @supports (-webkit-touch-callout: none) {
                            .pdf-logo-align
                            {
                                position: relative;
                                bottom: 215px;
                            }
                        }
                    }
                    @media print and (max-width: 767px) {
                        @supports (-webkit-touch-callout: none) {
                            .pdf-logo-align
                            {
                                position: relative;
                                bottom: 215px;
                            }
                        }
                    }
                    .row2-column2{
                        width: 52%;
                    }
                    @media print and (max-width: 414px) {
                        @supports (-webkit-touch-callout: none) {
                            .row2-column2{
                                width: 45%;
                            }
                        }
                    }
                    @media print and (max-width: 767px) {
                        @supports (-webkit-touch-callout: none) {
                            .row2-column2{
                                width: 45%;
                            }
                        }
                    }
                    .row3-column1 p{
                        font-size: 14px !important;
                    }
                    .pdf-align-text{
                        vertical-align: text-top;
                    }
                    .width-for-column{
                        width: 60%;
                        text-align: right;
                    }
                    .table-data{
                        visibility: hidden;
                    }
                    .QuickQuote-GovernmentNote{
                        color: ${fields.webQuoteTextColor};
                    }
                    .QuickQuote-TermsOfQuote{
                        color: ${fields.webQuoteTextColor};
                    }
                    .quote-prepared{
                        text-wrap: nowrap;
                    }
                    .width-for-column{
                        text-wrap: wrap;
                    }
                    .fixed-position{
                        display: flow;
                    }
                    .row3-margin-top{
                        position: relative !important;
                        bottom: 35px !important;
                    }
                    .font{
                        font-family: "Inter Tight", Arial !important;
                        font-weight: 400 !important;
                    }
                }
                @media print and (orientation: landscape) {
                    .item{
                        padding-right: 53px !important;
                    }
                }
           `,
        },
    };
    const tableHeaderStyle: React.CSSProperties = {
        padding: "8px",
        textAlign: "left",
        whiteSpace: "normal",
        color: "#ffffff",
        backgroundColor: "#58595b",
    };
    const tableCellStyle: React.CSSProperties = {
        padding: "8px",
        textAlign: "left",
        wordBreak: "break-word",
        whiteSpace: "normal",
        color: "black",
        backgroundColor: "#eeeeee",
    };


    const imageStyle: React.CSSProperties = {
        width: "50px",
        height: "30px",
        marginTop: "5px",
        objectFit: "contain"
    };


    const renderButtons = () => {
        if (quoteSubmitted) {
            return (
                <div>
                    <Button className="edit-quote" onClick={newWeQuoteClick}>New Quote</Button>
                    <Button className="submit-web-quote" onClick={openPrintDialog}>Print Quote</Button>
                </div>
            );
        }
        return (
            <div>
                <Button className="edit-quote" onClick={newWeQuoteClick}>Edit Quote</Button>
                <Button className="submit-web-quote" onClick={handleQuoteSubmit}>
                    Submit Web Quote
                </Button>
            </div>
        );
    };

    return (
        <>
            <StyledWrapper {...webquoteStyles.webQuote}>
                {isSubmitCLicked && (
                    <div className="overlay">

                        <span className="webQuoteSpinner">
                            <LoadingSpinner />
                        </span>
                    </div>

                )}
                <div className="container-main">

                    <tr>

                        <td colSpan={2} className="table-data">
                            {renderButtons()}
                        </td>
                    </tr>

                    <tr className="fixed-position">
                        <td className="row2-column1">
                            <br />
                            <span>Web Quote</span>
                        </td>
                        <td className="row2-column2">
                            {siteMessage("QuickQuote_OrderFromQuotation")}
                            <br />
                            <br />
                            {siteMessage("QuickQuote_InternationalOrderingNote")}
                            {quoteSubmitted && (
                                <div className="quote-numb">
                                    <p>Quote Number: {quoteNumber}</p>
                                </div>
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td className="pdf-logo-align"colSpan={2}>
                            <span className="logo">
                                {" "}
                                {fields.image && <img src={fields.image} alt="Logo" />}

                            </span>
                        </td>
                    </tr>
                    <tr className="row3-margin-top">
                        <td>
                            <div className="row3-column1">
                                {siteMessage("WebQuote_Address")}

                            </div>
                            <div className="row3-column1 add-margin-top">

                                <span>{data?.billTo?.customerNumber}</span>
                            </div>
                            <div className="row3-column1">


                                <span>{shipTo?.companyName}</span>
                            </div>
                            <div className="row3-column1">

                                <AddressInfoDisplay address1={shipTo?.address1 || ''}
                                    city={shipTo?.city || ''}
                                    postalCode={shipTo?.postalCode || ''}
                                    address2={shipTo?.address2}
                                    address3={shipTo?.address3}
                                    address4={shipTo?.address4}
                                    state={shipTo?.state?.name}
                                    country={shipTo?.country?.abbreviation}
                                >
                                </AddressInfoDisplay>

                            </div>
                        </td>
                        <td className="quote-detail">
                            <div className="quote-detail-div">
                                <tr className="row3-column2 ">
                                    <td><span className="quote-prepared">Quotation Prepared By:</span>   </td>
                                    <td className="width-for-column"><span>{session.userName}</span> </td>
                                </tr>
                                <tr className="row3-column2 ">
                                    <td><span>Quote date:</span>   </td>
                                    <td className="width-for-column"><span>{quoteDate}</span> </td>

                                </tr>
                                <tr className="row3-column2">
                                    <td><span>Valid until:</span>   </td>
                                    <td className="width-for-column"><span>{validTillDate}</span> </td>
                                </tr>
                                <tr className="row3-column2 ">
                                    <td className="quote-style"><span>Quote Name:</span>   </td>
                                    <td className="width-for-column">{quoteSubmitted && <span>{quoteName}</span>}
                                        {!quoteSubmitted && <span className="add-margin-textbox"><input type="text" value={quoteName} onChange={quoteNameChangeHandler}></input></span>}
                                    </td>
                                </tr>
                                <tr className="row3-column2 ">
                                    <td className="quote-style"><span>Notes/Attention:</span>   </td>
                                    <td className="width-for-column">{quoteSubmitted && <span>{quoteNotes}</span>}
                                        {!quoteSubmitted && <span><textarea className="" maxLength={2000} name="txtXRefSearch" value={quoteNotes} onChange={quoteNotesChangeHandler}
                                            rows={2}
                                        ></textarea></span>}
                                    </td>
                                </tr>
                            </div>
                        </td>
                    </tr>
                    <span className="gp-quote-total">Quote Total:{" "}{data?.cart?.orderSubTotalDisplay} USD</span>

                    <table className="row-space" style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                            <tr>
                                <th className="line" style={tableHeaderStyle}>Line</th>
                                <th className="item" style={tableHeaderStyle}>Aspen Item</th>
                                <th className="part-desc" style={tableHeaderStyle}>Part Description</th>
                                <th className="qty" style={tableHeaderStyle}>Qty</th>
                                <th className="unit-price" style={tableHeaderStyle}>Unit Price</th>
                                <th className="total" style={tableHeaderStyle}>Total</th>
                            </tr>
                        </thead>
                        <tbody className="font">
                            {(Array.isArray(data?.cart?.cartLines) && data?.cart?.cartLines.map((item, index) => (


                                <tr className="pdf-align-text" key={index}>
                                    <td className="line-counter" style={tableCellStyle}>
                                        {item.line}
                                    </td>
                                    <td className="aspen-item" style={tableCellStyle}>
                                        {item.erpNumber}
                                        <div className="onlyPrint">
                                            <a href={item.productUri} target="_blank" rel="noreferrer">
                                                <img
                                                    src={item.smallImagePath}
                                                    alt="Small"
                                                    style={imageStyle}
                                                />
                                            </a>
                                        </div>
                                        <div className="onlyUI">
                                            <img
                                                src={item.smallImagePath}
                                                alt="Small"
                                                style={imageStyle}
                                            />
                                        </div>
                                    </td>
                                    <td className="part-desc-content" style={tableCellStyle}>
                                        {item?.properties?.ifsErpDescription || item.shortDescription }
                                    </td>
                                    <td className="qty" style={tableCellStyle}>
                                        {item.qtyOrdered}
                                    </td>
                                    <td className="up" style={tableCellStyle}>
                                        {item?.pricing?.unitNetPriceDisplay}
                                    </td>
                                    <td className="total" style={tableCellStyle}>
                                        {item?.pricing?.extendedUnitNetPriceDisplay}
                                    </td>

                                </tr>

                            )))}

                        </tbody>
                    </table>
                    <span className="center-text">
                        {siteMessage("QuickQuote_WebQuoteCenterText")}
                    </span>
                    <span className="terms-condition">
                        <strong className="QuickQuote-GovernmentNote">
                            {siteMessage("QuickQuote_GovernmentNote")}
                        </strong>
                        <br />
                        <p className="QuickQuote-TermsOfQuote">
                            {siteMessage("QuickQuote_TermsOfQuote")}
                        </p>
                    </span>

                </div>
            </StyledWrapper>
        </>
    );
};

const webQuote: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withToaster(withHistory(withIsInShell(WebQuote)))),
    definition: {
        group: "Basic",
        displayName: "Web Quote",
        fieldDefinitions: [{
            fieldType: "Contextual",
            displayName: "Aspen Logo",
            name: fields.image,
            editorTemplate: "ImagePickerField",
            defaultValue: ""
        },{
            name: fields.webQuoteTextColor,
            displayName: "Web Quote Text Color",
            fieldType: "General",
            editorTemplate: "ColorPickerField",
            defaultValue: "#ff0000",
        }]
    },
};

export default webQuote;
